// Parses optimizely variation overrides from querystring params.
// e.g. `?force_optimizely=featureFlagName,variantName`
// https://docs.developers.optimizely.com/feature-experimentation/docs/forced-decision-methods-react
//

import qs from 'query-string';

export const extractForcedVariationFromUrl = () => {
  const queryParams = qs.parse(window?.location?.search);
  const searchParams = new URLSearchParams(queryParams);
  const forceOptimizelyValue = searchParams.get('force_optimizely');
  const [forcedFlagKey, ForcedVariationKey] =
    forceOptimizelyValue?.split(',') || [];
  return {
    forcedFlagKey,
    ForcedVariationKey,
  };
};

export const forceOptimizelyVariations = (optimizelyInstance) => {
  const { forcedFlagKey, ForcedVariationKey } = extractForcedVariationFromUrl();

  if (forcedFlagKey && ForcedVariationKey) {
    optimizelyInstance.setForcedDecision(
      {
        flagKey: forcedFlagKey,
      },
      { variationKey: ForcedVariationKey }
    );
  }
};
